import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InfoIconComponent } from './info-icon.component';

@NgModule({
  declarations: [InfoIconComponent],
  imports: [CommonModule],
  exports: [InfoIconComponent]
})
export class InfoIconModule {}
